import { render, staticRenderFns } from "./EditProductSkusView.vue?vue&type=template&id=242f0e02&scoped=true&"
import script from "./EditProductSkusView.vue?vue&type=script&lang=ts&"
export * from "./EditProductSkusView.vue?vue&type=script&lang=ts&"
import style0 from "./EditProductSkusView.vue?vue&type=style&index=0&id=242f0e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f0e02",
  null
  
)

export default component.exports